export enum DocumentViewerMutationTypes {
  SET_REDACT_DOCUMENT_DIALOG = 'SET_REDACT_DOCUMENT_DIALOG',
  SET_REDACT_DOCUMENT_ERROR = 'SET_REDACT_DOCUMENT_ERROR',
  SEARCH_BY_AI_PENDING = 'SEARCH_BY_AI_PENDING',
  SEARCH_BY_AI_PUSH_ENTITY = 'SEARCH_BY_AI_PUSH_ENTITY',
  SEARCH_BY_AI_SET_SUMMARY = 'SEARCH_BY_AI_SET_SUMMARY',
  SET_SEARCH_BY_AI_RESULTS = 'SET_SEARCH_BY_AI_RESULTS',
  SEARCH_BY_AI_ERROR = 'SEARCH_BY_AI_ERROR',
}
